import { useContext } from 'react';
import Location from '../../../ui-components/Location';
import { bookingState } from '../client-state/booking-state-context';
import { selecetedShopIdActionTypes } from '../../../redusers/selected-shop-id-reducer';
import useBookingMinimalShops from '../server-data/use-booking-minimal-shops';
import useBookingMinimalShop from '../server-data/use-booking-minimal-shop';

const LocationWithData = () => {
  const { data: minimalShops } = useBookingMinimalShops();
  const { data: minimalShop } = useBookingMinimalShop();
  const { state, dispatch } = useContext(bookingState);

  const handleShopChange = (shopId: string) => {
    dispatch({
      type: selecetedShopIdActionTypes.SELECTED_SHOP_ID_UPDATE,
      payload: shopId,
    });
  };

  return (
    <Location
      selectedShopId={state.selectedShopId}
      shop={minimalShop ?? undefined}
      shops={minimalShops ?? []}
      onChange={handleShopChange}
      error={Boolean(state.errors.location)}
    />
  );
};

export default LocationWithData;
